export const sort = [
  {
    label: "ID",
    name: "id",
    style: { width: 130 },
  },
  { label: "Nazwa", name: "name" },
  { label: "Label", name: "label", sortable: false },
  { label: "Platforma", name: "platforms", sortable: false },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
];
